import { builder, defaults } from 'common/js/configs';

import { formatConfigUnmarshaller as bannerUnmarshaller } from './banner-320x50';
import { Position } from 'common/js/creative-position';
import { redirectTypes } from '../../redirect-types/redirect-types.model';
import { backgroundWhite } from '../common/common-background';
import { AdParser } from '../../../../../legacy/common/js/AdParser';

const overriddenCommonFormatConfigUnmarshaller = {
  triggerImpressionAfterPreload: builder.boolean(
    'trigger_impression_after_preload',
    {
      l:'',
      d:'',
      defaultValue: false
    }
  )
};

export const formatConfigUnmarshaller = {
  ...overriddenCommonFormatConfigUnmarshaller,

  recommendedLinks: defaults.recommendedLinks,
  contentDiscovery: defaults.contentDiscovery,
  tag: builder.string('mraid_tag', {
    overrideType: 'tag',
    l:'',
    defaultValue: '',
    if: {
      valueOf: 'is_programmatic',
      is: 'false'
    }
  }),
  redirectType: builder.string('redirect_type', {
    overrideType: 'lookup',
    l:'',
    possibleValues: redirectTypes,
    if: {
      valueOf: 'is_programmatic',
      is: 'false'
    }
  }),

  isProgrammatic: builder.boolean('is_programmatic', {
    l:'',
    d:'',
    defaultValue: false
  }),

  isActiveViewInjected: builder.boolean('is_active_view_injected', {
    l:'',
    d:'',
    defaultValue: false
  }),

  injectOnViewable: builder.boolean('inject_on_viewable', {
    defaultValue: false
  }),

  useSimpleInjection: builder.boolean('use_simple_injection', {
    defaultValue: false
  }),

  containerSelector: builder.string('container_selector', {
    defaultValue: 'body'
  }),

  icon: builder.holder({
    useIcon: builder.boolean('use_icon', {
      defaultValue: false,
      l:'',
      d:''
    }),

    name: builder.string('icon_name', {
      l:'',
      d:'',
      if: 'use_icon'
    }),

    url: builder.icon('icon', {
      overrideType: 'image',
      l:'',
      d:'',
      if: 'use_icon'
    }),

    identifier: builder.string('identifier', {
      overrideType: 'hidden',
      l:'',
      d:'',
      if: 'use_icon',
      optional: true
    }),

    isAllowedAfterBrowser: builder.boolean('allow_icon_after_browser', {
      defaultValue: true
    })
  }),

  creativeEngagementUrl: builder.string('creativeEngagementUrl', {
    optional: true
  }),

  position: builder.string('creative_position', {
    defaultValue: 'center',
    possibleValues: [
      {
        name: 'Top',
        value: 'top'
      },
      {
        name: 'Center',
        value: 'center'
      },
      {
        name: 'Bottom',
        value: 'bottom'
      }
    ],
    d:''
  }),

  ...bannerUnmarshaller,
  ...backgroundWhite,
  shouldSendCloseCreativeTrack: builder.boolean('close_creative_track_enable', {
    defaultValue: false,
    d:'',
    l:''
  }),
  disableUseCustomClose: builder.boolean('disable_use_custom_close', {
    defaultValue: false
  }),
  adParser: builder.object('ad_parser', {
    l:'',
    d:'',
    overrideType: 'hidden',
    optional: true,
    defaultValue: undefined
  })
};

export interface RedirectConfigType {
  recommendedLinks: RecommendedLinksConfigType;
  contentDiscovery: ContentDiscoveryConfigType;
  tag: string;
  injectOnViewable: boolean;
  useSimpleInjection: boolean;
  containerSelector: string;
  touchForClose: boolean;
  expandBtn?: ExpandBtnConfigType;
  position?: Position;
  marginTop?: string;
  redirectType?: string;
  creativeEngagementUrl: string;
  useArrowBtn: boolean;
  skanTimeout?: number;
  useBtnAutoMargin?: boolean;
  shouldSendCloseCreativeTrack: boolean;
  disableUseCustomClose: boolean;
  adParser?: AdParser;
  isActiveViewInjected: boolean;
}
